interface HeadCell {
  id: string;
  label: string;
  sortable: boolean;
  brand?: string;
}

const headCells: readonly HeadCell[] = [
  {
    id: 'name',
    label: 'Attribute',
    sortable: true,
  },
  {
    id: 'region',
    label: 'Region',
    sortable: false,
  },
  {
    id: 'country',
    label: 'Country',
    sortable: true,
    brand: 'TH',
  },
  {
    id: 'updatedDate',
    label: 'Updated',
    sortable: true,
  },
  {
    id: 'requestDate',
    label: 'Requested',
    sortable: true,
  },
  {
    id: 'userCreated',
    label: 'Requested By',
    sortable: false,
  },
  {
    id: 'status',
    label: 'Status',
    sortable: true,
  },
  {
    id: 'moreOption',
    label: '',
    sortable: false,
  },
];

export default headCells;
